<div *ngIf="this.notesList?.length > 0; else noNotes">
  <wfdss-rte-existing-notes 
  [notesList]="this.notesList" 
  [sortingDataAccessor]="sortingDataAccessor"
  [columnMetaInformation]="columnMetaInfo" 
  (selectNote)="onClickExistingNoteFromTableRow($event)" 
  (deleteNote)="onClickDeleteNoteFromTableButton($event)">
    <ng-content></ng-content>
  </wfdss-rte-existing-notes>
  <button class="primary-button"
  [disabled]="(!this.showCreateButton) || this.formGroupForNoteInEdit?.dirty 
              || this.analysisFacadeService.canViewOrEditAnalysisInd === 'view'"
  (click)="onClickCreateNewNote()">Create a New Note</button>
</div>
<ng-template #noNotes>
  <h5>No saved notes for this analysis.</h5>
  <p>Create one below</p>
  <button class="primary-button"
  [disabled]="!this.showCreateButton || this.analysisFacadeService.canViewOrEditAnalysisInd === 'view'"
  (click)="onClickCreateNewNote()">Create a New Note</button>
</ng-template>
<wfdss-rte-create-note *ngIf="!editingExistingNote && this.analysisFacadeService.canViewOrEditAnalysisInd === 'edit'" 
  [resetForm$]="_resetCreate.asObservable()"
  [label]="currentNoteLabel" 
  [noteType]="this.createNoteTypeDroprownOptions"
  (save)="saveNote($event)" 
  (cancel)="onClickCancelNewNoteEdit($event)" 
  [saveText]="saveButtonText"
  [noteIdAccessor]="this.analysisNoteIdAccessor">
</wfdss-rte-create-note>
<wfdss-rte-edit-existing-note *ngIf="editingExistingNote" 
  [label]="currentNoteLabel" 
  [noteType]="this.createNoteTypeDroprownOptions"
  (save)="saveNote($event)" 
  (cancel)="onCancelExistingNoteEdit($event)" 
  [saveText]="saveButtonText"
  [fg]="editableNoteFG" 
  [note]="this.selectedNote"
  [noteReadonly]="this.noteReadonly || this.analysisFacadeService.canViewOrEditAnalysisInd === 'view'"
  [noteIdAccessor]="this.analysisNoteIdAccessor"
  (formGroupEmit)="formGroupForNoteInEdit=$event">
</wfdss-rte-edit-existing-note>